export const uploadFileReducerProfile = (state = '', action) => {
    switch (action.type) {
        case 'GET_PROFILE_IMAGE':
            return {
                ...state,
                file: action.payload,
                loading: action.loading ?? false
            }
        default:
            return state
    }
}
